var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueAssemble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "m8.84 3 14.202 2.504-1.29 7.316L7.55 10.316 8.84 3zm1.623 2.317 10.262 1.81-.595 3.376-10.263-1.81.596-3.376zM1 14.675l14.201-2.505 1.29 7.316L2.29 21.991 1 14.675zm2.317 1.622 10.262-1.81.596 3.377-10.263 1.81-.595-3.377z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueAssemble);
export default __webpack_public_path__ + "static/media/issue_assemble.daf8209b22b275797852eebc6034616d.svg";
export { ForwardRef as ReactComponent };